// extracted by mini-css-extract-plugin
export default {"selectReport":"SelectReport_selectReport__dNdGX","text":"SelectReport_text__9wOIn","divisor":"SelectReport_divisor__ScIWW"};